let tickIntervalId;

export const setTickIntervalId = (newTickIntervalId) => {
  tickIntervalId = newTickIntervalId;
};

export const getTickIntervalId = () => tickIntervalId;
